// extracted by css-extract-rspack-plugin
export default {"container":"container-FKE0V7","noTitle":"noTitle-EEzd8u"};